"use strict";

import React from 'react';
import defaultState from '../store/account-echeck-create-alternative-initial-state';
import { AccountEcheckCreateAlternativeProvider as Provider } from "../context/AccountEcheckCreateAlternativeContext";
import axios from "../utilities/axiosEcheckWrapper";
import localStorageTTL from "../../localStorageTTL";
import { withAlert } from 'react-alert'
import { withRouter } from 'react-router-dom';

class AccountEcheckCreateAlternativeProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = defaultState;
        const cancelToken = axios.CancelToken;
        this.axiosCancelSource = cancelToken.source();
        this.fetchAuthorizedEchecks = this.fetchAuthorizedEchecks.bind(this);
        this.handleFinancialAccountSubmit = this.handleFinancialAccountSubmit.bind(this);
        this.handleAuthorizeSubmit = this.handleAuthorizeSubmit.bind(this);
        this.setAuthorizeData = this.setAuthorizeData.bind(this);
        this.handleTermsOfServiceSubmit = this.handleTermsOfServiceSubmit.bind(this);
        this.setTermsOfServiceData = this.setTermsOfServiceData.bind(this);
        this.validateSteps = this.validateSteps.bind(this);
        this.setCurrentStep = this.setCurrentStep.bind(this);
        this.getCurrentStep = this.getCurrentStep.bind(this);
        this.validateFinancialAccountData = this.validateFinancialAccountData.bind(this);
        this.validateAuthorizeData = this.validateAuthorizeData.bind(this);
        this.validateTermsOfServiceData = this.validateTermsOfServiceData.bind(this);
        this.handleCreateEcheckSubmit = this.handleCreateEcheckSubmit.bind(this);
        this.setError = this.setError.bind(this);
    }

    componentDidMount() {
        this.fetchAuthorizedEchecks();
    }

    componentWillUnmount(){
        this.axiosCancelSource.cancel();
    }

    fetchAuthorizedEchecks(){
        this.setState(()=>{
            return {isFetchingEchecks: true};
        });
        axios.get(`echecks/accounts/echecks`, {
            params: {
                state: 'authorized',
            }
        })
            .then((response)=>{
                this.setState(()=>{ return {authorizedEchecks: [...response.data],}; });
            })
            .catch((error)=>{
                return false;
            }).finally(()=>{
            this.setState(()=>{
                return {isFetchingEchecks: false};
            });
        });
    }

    handleFinancialAccountSubmit( data={}){
        if(!!data) {
            this.setState(() => {
                return {
                    financialAccountData: {...data}
                };
            }, () => {
                this.validateSteps();
            });
        }
    }

    handleAuthorizeSubmit(data){
        if(!!data){
            this.setAuthorizeData(data);
        }
    }

    setAuthorizeData(data){
        this.setState(()=>{
            return {
                authorizeData: {...data}
            };
        }, ()=>{this.validateSteps();});
    }

    handleTermsOfServiceSubmit(data){
        if(!!data){
            this.setTermsOfServiceData(data);
        }
    }

    setTermsOfServiceData(data){
        this.setState(()=>{
            return {
                termsOfServiceData: {...data}
            };
        }, ()=>{this.validateSteps();});
    }

    setError(key='', message=''){
        const updatedErrors = {...this.state.errors};
        updatedErrors[key] = message;
        this.setState(()=>{
            return {errors: updatedErrors,};
        });
    }

    handleCreateEcheckSubmit(){
        if(this.getCurrentStep() === 3){
            const data = {
                ...this.state.financialAccountData,
                ...this.state.authorizeData,
                ...this.state.termsOfServiceData,
                tos_version: this.state.termsOfServiceVersion,
                pre_screen_report: JSON.stringify(this.state.financialAccountData.preScreenReport),
                financial_institution_report: JSON.stringify(this.state.authorizeData.financialInstitutionReport),
            }
            delete data.preScreenReport;
            delete data.financialInstitutionReport;

            this.setState(()=>{return {isCreatingEcheck: true};});
            axios.post(`echecks/accounts/echecks`, data)
                .then((response)=>{
                    this.props.alert.success('Echeck Created');
                    this.props.history.push('/echeck/accounts/echecks');
                })
                .catch((error)=>{
                    this.props.alert.error(error.data.message);
                    this.setError('createEcheck', error.data.message);
                }).finally(()=>{
                this.setState(()=>{return {isCreatingEcheck: false};});
            });
        }
    }

    validateFinancialAccountData(financialAccountData={}){
        const {
            bank_routing_number: bankRoutingNumber='',
            bank_account_number: bankAccountNumber='',
            preScreenReport = {},
        } = financialAccountData;
        const preScreenReportDecision = preScreenReport?.RESPONSE?.CONTENT?.DECISION?.decision?.code;
        return !!bankRoutingNumber
            && !!bankAccountNumber
            && (preScreenReportDecision === 'A' || preScreenReportDecision === 'W');
    }

    validateAuthorizeData(data={}){
        return !!data.for_payment_of && !!data.ach_acknowledgement && !!data.account_nick_name
            && !!data.account_name && !!data.bank_city && !!data.bank_state;
    }

    validateTermsOfServiceData(data={}){
        return !!data.agree_to_tos && !!data.scrolledToBottomOfTerms;
    }

    validateSteps(){
        const isValid = {...this.state.isValid};
        const {financialAccountData={}, authorizeData={}, termsOfServiceData={}} = this.state;
        isValid.step1 = this.validateFinancialAccountData(financialAccountData);
        isValid.step2 = this.validateAuthorizeData(authorizeData);
        isValid.step3 = this.validateTermsOfServiceData(termsOfServiceData);
        this.setState({isValid: isValid}, ()=>{this.setCurrentStep();});
    }

    setCurrentStep(){
        this.setState({currentStep: this.getCurrentStep()});
    }

    getCurrentStep(){
        const {isValid} = this.state;
        switch (true) {
            case !isValid.step1:
                return 0;
            case !isValid.step2:
                return 1;
            case !isValid.step3:
                return 2;
            case isValid.step1
            && isValid.step2
            && isValid.step3:
                return 3;
            default:
                return 0;
        }
    }

    render() {
        return (
            <Provider value={{
                ...this.state,
                handleFinancialAccountSubmit: this.handleFinancialAccountSubmit,
                handleAuthorizeSubmit: this.handleAuthorizeSubmit,
                handleTermsOfServiceSubmit: this.handleTermsOfServiceSubmit,
                handleCreateEcheckSubmit: this.handleCreateEcheckSubmit,
                validateSteps: this.validateSteps,
                setError: this.setError,
            }}> {this.props.children}</Provider>);
    }
}

export default withAlert()(withRouter(AccountEcheckCreateAlternativeProvider));
